import * as actions from "./actions";
import * as selectors from "./selectors";
import * as constants from "./constants";
import container from "./container";
import reducer from "./reducer";
import sagas from "./sagas";
import withCountry from "./withCountry";

export default {
  actions,
  Component: container,
  constants,
  createSagas: sagas,
  reducer,
  selectors,
  withCountry,
};
